import React, { useState, useEffect } from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import "../../styles/practitionerpage.css";
import "../../styles/homepage.css";
import { Link } from "react-router-dom";
import womanStory from "../../img/sharePelvicCareStory.png";
import { useDispatch } from "react-redux";
import { NewFooter } from "../../components/newFooter";
import butterfly1 from "../../img/Butterfly1.png";
import "../../styles/sharePelvicCareStory.css";
import { createIndividualOption } from "../../features/individualOptions/individualOptionsSlice";

export const SharePelvicCareStory = () => {
  const dispatch = useDispatch();

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  const [infoStory, setInfoStory] = useState({
    info: "",
    firstName: "",
    lastName: "",
    email: "",
    option: "STORY",
  });
  const handleChange = (e) => {
    setInfoStory({ ...infoStory, [e.target.name]: e.target.value });
  };

  const [basicModal, setBasicModal] = useState(false);

  const toggleShow = () => setBasicModal(!basicModal);

  const submitData = (e) => {
    // e.preventDefault()
    if (
      infoStory?.firstName == "" ||
      infoStory?.lastName == "" ||
      infoStory?.email == "" ||
      infoStory?.option != "STORY" ||
      infoStory?.info == ""
    ) {
      return console.log("error");
    } else {
      dispatch(createIndividualOption(infoStory));
    }
    // dispatch(createIndividualOption(data))
  };

  return (
    <div>
      <div className="bg-pelvicCareStory">
        <div className="padding-logo-aling pt-4">
          <h2 className="padding-top-userpages fs-48-32-30">
            Share my Pelvic Care Story
          </h2>
        </div>
        <div className="padding-logo-aling">
          <p className="mt-4 fs-20-18 text-dm padding-right">
            Sharing helps us all become more aware and feel a little less alone.
            We believe that sharing one woman’s pelvic care journey can inspire
            and empower the next woman who may be suffering in silence, to ask
            for help. If you’ve got a story to share, we’d love to hear it.
          </p>
          <p className="mt-4 m-0 fs-20-18 text-dm padding-right">
            Submit the information below and we will be in touch.
          </p>
        </div>
        <div className="d-flex justify-content-between align-baseline padding-logo-aling">
          <div>
            <div>
              <div className="d-grid mt-4 mb-4">
                <label className="text-dm">Tell us your story:</label>
                <textarea
                  className="textarea-waitlist"
                  value={infoStory?.info}
                  name="info"
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="d-grid mt-4 mb-4">
                <label className="text-dm">First name</label>
                <input
                  className="input-waitlist"
                  value={infoStory?.firstName}
                  name="firstName"
                  onChange={handleChange}
                ></input>
              </div>
              <div className="d-grid mt-4">
                <label className="text-dm">Last name</label>
                <input
                  className="input-waitlist"
                  value={infoStory?.lastName}
                  name="lastName"
                  onChange={handleChange}
                ></input>
              </div>
              <div className="d-grid mt-4">
                <label className="text-dm">Email address</label>
                <input
                  className="input-waitlist"
                  value={infoStory?.email}
                  name="email"
                  onChange={handleChange}
                ></input>
              </div>
              {/* <div className="d-grid mt-4">
                <label>Choose a password (9 characters)</label>
                <input className="input-waitlist"></input>
              </div> */}
              <div className="mt-5 controller-width-text">
                <p className="fs-10">
                  I consent to Elana Inc. processing data I provide, so that
                  Elana Inc. can provide services to me. In addition, by
                  clicking ‘Share My Story’ I acknowledge that I have read and
                  agree to Elana’s Privacy Policy and Terms and Conditions. I
                  consent to Elana sharing my story on the blog and in
                  Elana-related communications. I agree to receive emails and
                  updates from Elana
                </p>
              </div>
              <div className="pt-4 pb-4">
                <button
                  className="button-newindividualpage blue-hover"
                  onClick={() => {
                    submitData(infoStory);
                    toggleShow();
                  }}
                >
                  SHARE MY STORY
                </button>
              </div>
            </div>
          </div>
          <div>
            <img
              src={womanStory}
              className="align-ima padding-right no-phone"
            />
          </div>
        </div>

        <MDBModal show={basicModal} setShow={setBasicModal} tabIndex="-1">
          <MDBModalDialog size="lg" rounded className="p-5">
            <MDBModalContent className="bg-modal-option">
              <MDBModalBody>
                <div className="d-flex justify-content-end">
                  <MDBBtn
                    className="btn-close"
                    color="none"
                    onClick={toggleShow}
                  ></MDBBtn>
                </div>
                <div className="items-controller mt-3 mb-3">
                  <img src={butterfly1} className="butterfly1"></img>
                </div>
                <p className="text-center px-3 mt-3 text-dm fs-20">
                  Thank you for Sharing Your Story here at Elana.
                </p>
                <p className="text-center px-3 mt-3 text-dm fs-20">
                  Check your inbox for an email confirmation.<br/>We’re so glad
                  to be a part of your pelvic care journey!
                </p>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </div>
      <NewFooter />
    </div>
  );
};
